const initialState = {
  token: null,
  user: null,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {    
    case 'SET_CREDENTIALS':
      return { ...state, token: action.payload.token, user: action.payload.user };

    // Drop the signed-out JWT, so redux-persist stops keeping it in
    // localStorage persist:root.
    case 'USER_LOGOUT':
      return initialState;

    default:
      return state;
  }
};

export default authReducer;
